import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable, of, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { v4 as uuid } from 'uuid';
import { environment } from '../../environments/environment';

@Injectable()
export class CreateRestService {
  constructor(
    private http: HttpClient,
    private snackbar: MatSnackBar,
  ) {}

  handleError(err) {
    this.snackbar.open('Error: ' + err.message, 'Dismiss');
    return observableThrowError(err || 'Server error');
  }

  handleDeleteError(err) {
    if (!(err instanceof HttpErrorResponse) && !(err.status === 404)) {
      this.snackbar.open('Error: ' + err.message, 'Dismiss');
    }

    return observableThrowError(err || 'Server error');
  }

  getConfiguration() {
    return this.get('/Configuration/');
  }


  submitFeedback(feedback: string) {
    const feedbackText = {
      feedbackUUID: uuid(),
      feedback,
    };

    return this.post('/Feedback/submitFeedback', feedbackText).pipe(
      map((res) => res['status']),
      catchError(e => {
        return this.handleError(e);
      }));
  }

  submitFeedbackExternal(feedback: string, firstName: string, lastName: string, email: string, rank?: string): Observable<void> {
    if (!feedback || !firstName || !lastName || !email) {
      return of(null);
    }

    let name = rank ? rank + ' ' : '';
    name += firstName + ' ' + lastName;

    return this.http.post(`${environment.externalSupportService}requests.json`, {
      request: {
        requester: {
          name,
          email,
        },
        subject: 'FitForce Feedback - Planner',
        comment: {
          body: feedback,
        }
      }
    }).pipe(
      map(() => null),
      catchError(e => {
        return this.handleError(e);
      }),
    );
  }

  sharePlan(planDayId: string) {
    return this.post('/XLSExport/', {
      planDayUUID: planDayId
    }).pipe(
      map((res) => res['taskUUID']),
      catchError(e => {
        return this.handleError(e);
      }));
  }

  checkTask(taskUuid: string) {
    return this.get('/XLSExport/status/' + taskUuid, {
      responseType: 'blob'
    }).pipe(
      catchError(e => {
        return this.handleError(e);
      }));
  }

  private get (route: string, options?) {
    if (options) {
      return this.http.get(this.buildRoute(route), options);
    }
    return this.http.get(this.buildRoute(route));
  }

  private post (route: string, data: any) {
    return this.http.post(this.buildRoute(route), data);
  }

  private buildRoute (route: string) {
    return environment.applySubstitutions(environment.api_url) + 'api' + route;
  }
}
